import { useEffect } from 'react';
import { useState } from "react";
import { motion } from "framer-motion";
import emailjs from 'emailjs-com';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import mapVideo from '../../public/assets/videos/investor-rise-bg-map.mp4';
// import { Button } from '@/components/ui/button';
import Logo  from '../../public/assets/images/logo2.png';

export default function ContactUs() {

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    projectDetails: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        {
          full_name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          project_details: formData.projectDetails,
        },
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          setFormData({
            fullName: "",
            email: "",
            phone: "",
            projectDetails: "",
          });
        },
        (error) => {
          alert("Failed to send message. Try again.");
          console.error(error);
        }
      );
  };

 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);




  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
    {/* Background Image with Zoom Out */}
    <motion.div
      initial={{ scale: 1.2 }}
      animate={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/Contact-hero-img.jpg')" }}
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-30" />

    {/* Heading on the Left */}
    <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0">
      <motion.h1
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold bg-black bg-opacity-40 px-4 py-3 sm:px-6 sm:py-6 rounded-xl shadow-xl max-w-[90%] sm:max-w-[70%]"
      >
        Contact Us
      </motion.h1>
    </div>
  </div>




    {/* Contact Info Section */}
<div className="relative h-[500px] md:h-[280px] overflow-hidden">
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
  >
    <source src={mapVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Green Overlay */}
  <div className="absolute top-0 left-0 w-full h-full bg-slate-950 bg-opacity-30 z-10" />

  {/* Contact Info Content */}
  <div className="relative z-20 h-full flex items-center">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-around text-white text-center gap-8 w-full">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaMapMarkerAlt size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">Adamstown, Dublin, Ireland</h3>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaPhoneAlt size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">+353 892256187</h3>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaEnvelope size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">info@aliconstructions.com</h3>
      </motion.div>
    </div>
  </div>
</div>


    


<div className="py-20 px-4 md:px-20 bg-gradient-to-b from-white via-gray-50 to-white min-h-screen font-sans overflow-x-hidden">

    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16">
      {/* Left Side Logo & Heading */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="w-full md:w-1/2 flex justify-center"
      >
        <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
          <img
            src={Logo}
            alt="Company Logo"
            className="w-28 md:w-56 drop-shadow-xl animate-float"
          />
          <div className="flex text-3xl md:text-6xl font-bold tracking-tight text-black">
            <motion.span
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              ALI
            </motion.span>
            <motion.span
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 1 }}
              className="text-black font-medium ml-2 font-bold "
            >
              CONSTRUCTION
            </motion.span>
          </div>
        </div>
      </motion.div>

      {/* Right Side Enquiry Card */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 3 }}
        className="w-full md:w-1/2 bg-slate-800 p-10 rounded-3xl shadow-2xl text-center"
      >
         <motion.div
      initial={{ clipPath: "inset(0 100% 0 0)" }}
      whileInView={{ clipPath: "inset(0 0% 0 0)" }}
      transition={{ duration: 1.2, ease: "easeInOut", delay: 1 }}
      viewport={{ once: true }}
      className="bg-white/90 p-8 rounded-lg shadow-lg"
    >
      <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-slate-900">
        Get In Touch With Us
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <textarea
          name="projectDetails"
          placeholder="Project Details"
          value={formData.projectDetails}
          onChange={handleChange}
          rows="4"
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

         <button className="relative inline-block px-4 py-2 text-xl font-semibold text-white bg-slate-900  overflow-hidden group w-full">
            <span className="absolute inset-0 bg-gradient-to-r from-teal-600 to-teal-600 transition-all duration-500 ease-in-out group-hover:w-full group-hover:left-0 animate-slide-bg"></span>
            <span className="relative z-10 group-hover:text-white transition-colors duration-300">
              Contact
            </span>
              </button>

      </form>
    </motion.div>
      </motion.div>
    </div>


</div>










    
      {/* Map Section */}
      <motion.div
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  className="relative w-full h-[300px] md:h-[600px] overflow-hidden"
>   
  <div className="w-full h-full">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d159068.76235166937!2d-6.41085324283766!3d53.32441115704573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e80ea27ac2f%3A0xa00c7a9973171a0!2sDublin%2C%20Ireland!5e1!3m2!1sen!2s!4v1779359446549!5m2!1sen!2s"
      className="w-full h-full border-0 filter grayscale contrast-125 brightness-90"
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      style={{ display: "block" }} // This ensures no inline overflow
    ></iframe>
  </div>
  <div className="absolute top-0 left-0 w-full h-full bg-slate-900 opacity-30 pointer-events-none" />
</motion.div>


    </div>
  );
}
